import { service } from '../index.js'

// PC端登录相关
export const pc = {
  // 登录
  login: (data) => {
    return service.post('/auth/login', data)
  },
  
  // 退出登录
  logout: () => {
    return service.post('/auth/logout')
  },
  
  // 获取用户信息
  getUserInfo: () => {
    return service.get('/auth/user-info')
  },
  
  // 修改密码
  changePassword: (data) => {
    return service.post('/auth/change-password', data)
  },

  // ========== 用户管理 ==========
  
  // 获取用户列表
  getUserList: (params) => {
    return service.get('/auth/user/list', { params })
  },
  
  // 获取单个用户信息
  getUser: (id) => {
    return service.get(`/auth/user/${id}`)
  },
  
  // 创建用户
  createUser: (data) => {
    return service.post('/auth/user', data)
  },
  
  // 更新用户
  updateUser: (id, data) => {
    return service.put(`/auth/user/${id}`, data)
  },
  
  // 重置密码
  resetPassword: (id, password) => {
    return service.put(`/auth/user/${id}/password`, { password })
  },
  
  // 删除用户
  deleteUser: (id) => {
    return service.delete(`/auth/user/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/pc.js